<template>
  <el-card v-loading="loading">
    <div slot="header" class="clearfix">
      <span>Saját feladataim</span>
    </div>
    <el-table
      v-if="todos.length"
      :data="todos"
    >
      <title-column />
      <status-column type="myTodos" />
      <deadline-column />
    </el-table>
    <div v-if="!loading && todos.length === 0" style="text-align: center;">
      <el-alert
        :title="`Az összes feladatoddal végeztél! Eddig összesen ${doneTodos.length} feladatot oldottál meg.`"
        type="success"
        show-icon
        center
        :closable="false"
      />
      <el-image src="/notodo.svg" style="-webkit-filter: opacity(20%);filter: opacity(20%); margin-top: 20px"/>
    </div>
  </el-card>
</template>

<script>
import TitleColumn from '../todos/columns/Title';
import DeadlineColumn from '../todos/columns/Deadline';
import StatusColumn from '../todos/columns/Status';

export default {
  components: {
    DeadlineColumn,
    TitleColumn,
    StatusColumn
  },
  computed: {
    todos() {
      return this.$store.getters['todo/myTodos'];
    },
    doneTodos() {
      return this.$store.getters['todo/myDoneTodos'];
    },
    loading() {
      return this.$store.getters['todo/myLoading'];
    },
  },
  async mounted() {
    await this.$store.dispatch('todo/fetchMyTodos');
  }
};
</script>
